// src/themes/lino/elements/Header/HeaderMegaMenuBackdrop.tsx
'use client';

import { AnimatePresence, motion } from 'motion/react';
import { useMegaMenuStore } from '@/stores/megaMenuStore';

export default function HeaderMegaMenuBackdrop() {
    const isOpen = useMegaMenuStore(s => s.isOpen);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    key="mega-menu-backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    // از top-4 شروع می‌شه که همون مارجین بالای HeaderContainer هست
                    // این نوار باریک بالا اصلا زیر بلر نمی‌ره و سفید (پس‌زمینه‌ی خود صفحه) می‌مونه
                    className="fixed top-4 inset-x-0 bottom-0 z-30 backdrop-blur-md bg-primary-950/10 pointer-events-none"
                />
            )}
        </AnimatePresence>
    );
}